import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';

const TechnicalScope = styled.div`
  text-align: center;
  margin-top: 100px;
  ul {
    margin-top: 50px;
    text-align: left;
    @media ${({ theme }) => theme.media.tablet} {
      width: 70%;
    }

    li {
      text-align: left;
      margin: 7px;
      font-size: 20px;

      span {
        font-weight: bold;
      }
    }
  }
`;

const TechnicalTeamActivities = () => (
  <>
    <TechnicalScope>
      <HeadlineOne>
        Pozostałe działania możliwe do realizacji przez zespół techniczny
      </HeadlineOne>
      <Paragraph>
        W ramach kolejnych zleceń możemy prowadzić komplety proces inwestycyjny
        z uwzględnieniem takich dokumentów jak:
      </Paragraph>
      <ul>
        <li>
          Opracowanie Karty informacyjnej przedsięwzięcia wraz z wnioskiem o
          Decyzję Środowiskową;
        </li>
        <li>
          Opracowanie wniosku wraz ze wsparciem w uzyskaniu Warunków Zabudowy;
        </li>
        <li>
          Opracowanie wniosku o Warunki Przyłączenia do Sieci
          elektroenergetycznej OSD;
        </li>
        <li>
          Opracowanie dokumentacji Zakupowej (SIWZ) w odniesieniu do planowanej
          inwestycji;
        </li>
        <li>
          Uzyskanie pozwoleń i zgód administracyjnych wymaganych dla planowanej
          instalacji wytwarzania <br />
          <span>
            /koncesja na wytwarzanie energii elektrycznej w źródle OZE/.
          </span>
        </li>
        <Paragraph>
          Wskazane powyżej działania dodatkowe związane z procesem inwestycyjnym
          na życzenie Klienta mogą zostać wycenione indywidualnie w formule step
          by step lub w ramach zlecenia kompleksowego.
        </Paragraph>
      </ul>
    </TechnicalScope>
  </>
);

export default TechnicalTeamActivities;
